"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFileJson = function IconFileJson(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16 18v-1H5V9h11V4H4v16h10c1.1 0 2-.9 2-2m2-9V2H2v20h12c2.2 0 4-1.8 4-4v-1h4V9zm-8.08 6.377c.918 0 1.562-.56 1.562-1.33 0-.665-.427-1.057-1.1-1.288l-.468-.161c-.47-.161-.721-.343-.721-.672 0-.364.287-.609.742-.609.392 0 .742.175 1.078.469l.35-.609c-.441-.343-.896-.511-1.414-.511-.875 0-1.456.518-1.456 1.267 0 .623.44 1.043 1.099 1.274l.469.161c.49.175.714.357.714.686 0 .392-.336.672-.847.672-.441 0-.91-.21-1.26-.525l-.357.616c.44.35 1.015.56 1.61.56m-3.559-.07c.826.007 1.267-.504 1.267-1.274V10.75h-.693v3.22c0 .455-.259.658-.574.658h-.623v.672zm10.08-2.282c0 1.351-.924 2.359-2.226 2.359-1.295 0-2.212-1.008-2.212-2.359 0-1.358.91-2.359 2.212-2.359s2.226 1.008 2.226 2.359m-2.226 1.68c-.896 0-1.49-.714-1.49-1.68s.587-1.68 1.49-1.68 1.505.714 1.505 1.68c0 .959-.609 1.68-1.505 1.68m3.686-2.877V15.3h-.693v-4.55h.763l2.338 3.479V10.75h.693v4.55h-.77z",
    clipRule: "evenodd"
  })));
};

export { IconFileJson, IconFileJson as default };
